import React, { useState } from "react";
import { ReactComponent as NoteIcon } from "../../../images/note-2_blue.svg";
import { ReactComponent as ImageIcon } from "../../../images/file_blue.svg";
import EmailAttachmentPreview from "../../common/email-viewer/EmailAttachmentPreview";
import {
  MimeAttachmentContent,
  fileTypeToMimeType,
  resolveFileExtension,
} from "../../common/email-viewer/emailAttachmentUtils";
import "../../common/email-viewer/emailViewer.scss";
import "../../pickup-approval/doc-viewer/documentViewer.scss";

export interface PickupDocument {
  src: string;
  fileType: string;
  alt: string;
  type: string;
}

interface PickupDocImageViewerProps {
  documents: PickupDocument[];
}

const IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp"];

export const PickupDocImageViewer: React.FC<PickupDocImageViewerProps> = ({ documents }) => {
  const [previewIndex, setPreviewIndex] = useState<number | null>(0);

  const attachments: MimeAttachmentContent[] = documents.map((doc) => {
    const ext = resolveFileExtension(doc.fileType, doc.src);
    return {
      filename: `${doc.type}.${ext}`,
      mimeType: fileTypeToMimeType(ext),
      url: doc.src,
    };
  });

  const previewAttachment = previewIndex != null ? attachments[previewIndex] : null;

  if (!documents.length) {
    return null;
  }

  return (
    <div className="xgs-pickup-doc-viewer">
      <div className="xgs-pickup-doc-viewer__attachments">
        <div>
          <div className="xgs-pickup-doc-viewer__attachments-list">
            {attachments.map((attachment, index) => {
              const isPreviewing = previewIndex === index;
              return (
                <div
                  key={`${attachment.filename}-${index}`}
                  onClick={() => setPreviewIndex(index)}
                  className={`xgs-pickup-doc-viewer__attachment${isPreviewing ? " xgs-email-viewer__attachment--active" : ""
                    }`}
                >
                  <div className="xgs-email-viewer__attachment-icon">
                    {IMAGE_TYPES.includes(attachment.mimeType) ? <ImageIcon /> : <NoteIcon />}
                  </div>
                  <div className="xgs-email-viewer__attachment-info">
                    <span className="xgs-email-viewer__attachment-name">{documents[index].type}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div>
          {previewAttachment && (
            <EmailAttachmentPreview
              showPreview={false}
              attachment={previewAttachment}
              onClose={() => setPreviewIndex(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
